// import { createLogic } from "redux-logic";
import logic from "src/utils/genLogic";
import { ActionTypes } from "./actions";
import { push } from "connected-react-router";

const apiNamespace = "Cee";

const getAllCeeLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_ALL_CEE,
  showErrorMessage: true,
  showSuccessMessage: false,
});

const getAllCeeTasksLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_ALL_CEE_TASKS,
  showErrorMessage: true,
  showSuccessMessage: false,
});
const getAllCeeSpotsLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_ALL_CEE_SPOTS,
  showErrorMessage: true,
  showSuccessMessage: false,
});
const getAllMeetsLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_ALL_MEETS,
  showErrorMessage: true,
  showSuccessMessage: false,
});

const getCeeLogic = logic(apiNamespace, {
  actionName: ActionTypes.GET_CEE,
  showErrorMessage: true,
  showSuccessMessage: false,
});

const addCeeLogic = logic(apiNamespace, {
  actionName: ActionTypes.ADD_CEE,
  showErrorMessage: true,
  successMessage: "CEE created successfully",
  showSuccessMessage: true,
  successCb: (dispatch) => {
    dispatch(push("/cee/list"));
  },
});

const deleteCeeLogic = logic(apiNamespace, {
  actionName: ActionTypes.DELETE_CEE,
  showErrorMessage: true,
  successMessage: "CEE Deleted successfully",
  showSuccessMessage: true,
});
const editCeeLogic = logic(apiNamespace, {
  actionName: ActionTypes.EDIT_CEE,
  showErrorMessage: true,
  showSuccessMessage: "CEE Edited Successfully",
  showSuccessMessage: true,
  successCb: (dispatch) => {
    dispatch(push("/cee/list"));
  },
});

export default [
  getAllCeeLogic,
  getCeeLogic,
  addCeeLogic,
  deleteCeeLogic,
  editCeeLogic,
  getAllCeeTasksLogic,
  getAllCeeSpotsLogic,
  getAllMeetsLogic,
];
